<template>
  <b-alert show dismissible :variant="notification.type">
    <h4 v-if="notification.title" class="alert-heading">
      {{ notification.title }}
    </h4>
    {{variant.toUpperCase()}}: {{ notification.message }}
  </b-alert>
</template>

<script>
export default {
  props: ["notification"],
};
</script>